import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import "./AddConfigurations.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from "../../axiosInstance";
import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

const DEFAULT_COORDINATES = [37.7749, -122.4194]; // Default coordinates (San Francisco)

const RaceConfigurationsMap = () => {
  const history = useHistory();
  const [tracks, setTracks] = useState([]); // Tracks fetched from the API
  const [loading, setLoading] = useState(true); // Loading state
  const [map, setMap] = useState(null); // Leaflet map instance
  const [drawnItems, setDrawnItems] = useState(new L.FeatureGroup()); // Layer for drawn shapes
  const [selectedTrack, setSelectedTrack] = useState(null); // Selected track details
  const [trackDetails, setTrackDetails] = useState({
    name: "",
    configurationName: "",
    direction: "",
  });

  useEffect(() => {
    const fetchTracks = async () => {
      const token = localStorage.getItem("token");
      const userId = 1; // Replace this with dynamic user ID if needed
      try {
        const response = await axiosInstance.get(`/track?userId=${userId}`, {
          headers: {
            Authorization: token,
          },
        });

        if (response.data.success) {
          setTracks(response.data.data); // Store tracks
        } else {
          toast.error("Failed to fetch tracks.");
        }
      } catch (error) {
        console.error("Error fetching tracks:", error);
        toast.error("Error fetching tracks.");
      } finally {
        setLoading(false);
        initializeMap(...DEFAULT_COORDINATES, "Default Location"); // Initialize with default location
      }
    };

    fetchTracks();
  }, []);

  useEffect(() => {
    if (selectedTrack && selectedTrack.address) {
      fetchCoordinates(selectedTrack.address);
    }
  }, [selectedTrack]);

  const fetchCoordinates = async (address) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          address
        )}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const { lat, lon } = data[0];
        updateMap(lat, lon, selectedTrack.trackName);
      } else {
        toast.error("Could not find location for the selected track.");
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      toast.error("Failed to fetch coordinates for the track address.");
    }
  };

  const initializeMap = (latitude, longitude, trackName) => {
    const mapInstance = L.map("gps-map", {
      center: [latitude, longitude],
      zoom: 14,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(mapInstance);

    // Add drawing tools
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: drawnItems, // Allows editing of drawn shapes
      },
      draw: {
        polyline: false,
        polygon: true,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: true, // Disable circle markers
      },
    });

    // Add the feature group for drawn items to the map
    drawnItems.addTo(mapInstance);

    // Add the drawing controls to the map
    mapInstance.addControl(drawControl);

    // Add a center map button
    const CenterControl = L.Control.extend({
      options: { position: "topleft" }, // Position of the button

      onAdd: function () {
        const container = L.DomUtil.create("div", "leaflet-bar leaflet-control leaflet-control-custom");

        container.innerHTML = "🧭"; // Button content (can be customized)
        container.style.backgroundColor = "white";
        container.style.width = "30px";
        container.style.height = "30px";
        container.style.lineHeight = "28px";
        container.style.textAlign = "center";
        container.style.cursor = "pointer";
        container.style.fontSize = "18px";

        container.onclick = function () {
          // Center the map to the selected track or default coordinates
          const centerCoordinates = selectedTrack
            ? [selectedTrack.latitude, selectedTrack.longitude]
            : DEFAULT_COORDINATES;
          mapInstance.setView(centerCoordinates, 14);
        };

        return container;
      },
    });

    // Add the custom center button to the map
    mapInstance.addControl(new CenterControl());

    // Event listener for created shapes
    mapInstance.on(L.Draw.Event.CREATED, (event) => {
      const { layer } = event;
      drawnItems.addLayer(layer); // Add the shape to the layer
      console.log("Shape drawn:", layer.toGeoJSON()); // Log GeoJSON data
    });

    setMap(mapInstance);
  };

  const updateMap = (latitude, longitude, trackName) => {
    if (map) {
      map.setView([latitude, longitude], 15);
    }
  };

  const handleTrackChange = (e) => {
    const trackName = e.target.value;
    setTrackDetails({ ...trackDetails, name: trackName });

    const track = tracks.find((t) => t.trackName === trackName);
    if (track) {
      setSelectedTrack(track);
    }
  };

  const handleSaveChanges = async () => {
  if (!trackDetails.name || !trackDetails.configurationName || !trackDetails.direction) {
    toast.error("Please fill out all required fields.");
    return;
  }

  const selectedTrack = tracks.find((track) => track.trackName === trackDetails.name);

  if (!selectedTrack) {
    toast.error("Invalid track selected. Please try again.");
    return;
  }

  // Extract GeoJSON for all drawn items (polygons)
  const polygons = [];
  drawnItems.eachLayer((layer) => {
    if (layer instanceof L.Polygon) {
      polygons.push(layer.toGeoJSON());
    }
  });

  if (polygons.length === 0) {
    toast.error("Please draw at least one polygon on the map.");
    return;
  }

  // Prepare configuration data
  const configData = {
    trackId: selectedTrack.trackId,
    configurationName: trackDetails.configurationName,
    direction: trackDetails.direction,
    polygons, // Add the polygons GeoJSON array
  };

  console.log("Configuration Data to be sent:", configData);

  try {
    const token = localStorage.getItem("token");
    const response = await axiosInstance.post("/config/add", configData, {
      headers: {
        Authorization: token,
      },
    });

    if (response.data.success) {
      toast.success("Configuration added successfully!");
      history.push("/configurations");
    } else {
      toast.error("Error adding configuration.");
    }
  } catch (error) {
    console.error("Failed to add configuration", error);
    toast.error("Error adding configuration. Please try again.");
  }
};


  return (
    <>
      <ContentWrapper>
        <Container fluid className="pb-0" id="trckcfrm">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/track">Tracks</Breadcrumb.Item>
            <Breadcrumb.Item active>Add Configurations</Breadcrumb.Item>
          </Breadcrumb>
          {loading ? (
            <Row
              className="text-center w-100"
              style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner animation="border" />
            </Row>
          ) : (
            <>
              <Row className="add_trck_form">
                <Col xs={12} md={5} className="form-section">
                  <div className="form-group">
                    <label htmlFor="trackName">Track Name</label>
                    <select
                      className="form-control"
                      id="trackName"
                      value={trackDetails.name}
                      onChange={handleTrackChange}
                    >
                      <option value="">Select Track Name</option>
                      {tracks.map((track) => (
                        <option key={track.trackId} value={track.trackName}>
                          {track.trackName}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>

                <Col xs={12} md={5}>
                  <div className="form-group">
                    <label htmlFor="direction">Direction</label>
                    <select
                      className="form-control"
                      id="direction"
                      value={trackDetails.direction}
                      onChange={(e) =>
                        setTrackDetails({ ...trackDetails, direction: e.target.value })
                      }
                    >
                      <option value="">Select Direction</option>
                      <option value="Clockwise">Clockwise</option>
                      <option value="Counterclockwise">Counterclockwise</option>
                    </select>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={5}>
                  <div className="form-group">
                    <label htmlFor="configurationName">Configuration Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="configurationName"
                      autoComplete="off"
                      placeholder="Enter Configuration Name"
                      value={trackDetails.configurationName}
                      onChange={(e) =>
                        setTrackDetails({ ...trackDetails, configurationName: e.target.value })
                      }
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12} className="mt-4">
                  <label htmlFor="GPS_Layout">GPS Layout</label>
                  <div id="gps-map" style={{ height: "700px", width: "100%" }}></div>
                </Col>
              </Row>

              <Row className="mt-3" id="sc_btn">
                <Col xs={12} className="text-right">
                  <button onClick={handleSaveChanges} className="btn btn-primary sv_btn">
                    Save Changes
                  </button>
                </Col>
              </Row>
            </>
          )}
        </Container>
        <ThinFooter />
        <Toaster />
      </ContentWrapper>
    </>
  );
};

export default RaceConfigurationsMap;
